import React from 'react';
import { Helmet } from 'react-helmet';
import { isMobileOnly } from 'react-device-detect';
import { isPortraitTablet } from '../../../app';
import { ScrollToTop } from '../../../common/scripts/scroll-to-top';
import { BackLink } from '../../../common/elements/back-link/back-link';
import { PictureBlock } from '../../../common/elements/picture-block/picture-block';
import { ContentBlock } from '../../../common/elements/content-block/content-block';
import { Title } from '../../../common/elements/title/title';
import { Paragraph } from '../../../common/elements/paragraph/paragraph';
import { ExternalLink } from '../../../common/elements/external-link/external-link';

import css from './../info.module.scss';

export const SexualHealth = () => {
    return (
        <ScrollToTop>
            <Helmet>
                <title>Sexual Health | Nieuwezijds Gay Sauna Amsterdam</title>
                <meta
                    name="description"
                    content="The sexual health policy of the Nieuwezijds Gay Sauna in Amsterdam."
                />
            </Helmet>
            <section className={css.root}>
                <PictureBlock />
                <ContentBlock position="2">
                    {(isMobileOnly || isPortraitTablet) && (
                        <BackLink href="/info" text="info" />
                    )}
                    <Title as="h1" text="Sexual Health" />

                    <Paragraph>
                        we want our sauna to be a safe place for everyone. keep
                        it safe & sane - know your hiv status, protect yourself
                        & others with condoms, prep or hiv medication. we
                        strongly recommend you to use condoms to prevent most
                        sti's. condoms and lube ("wet stuff", water-based) are
                        available free of charge
                    </Paragraph>

                    <Paragraph>
                        <strong>Attention everyone:</strong> Mpox is making a
                        comeback in our community. Inform yourself, get a
                        vaccination,{' '}
                        <ExternalLink
                            href="https://www.mantotman.nl/nl/soas-hiv/alle-soas/mpox"
                            text="check out this page"
                        />
                        .
                    </Paragraph>

                    <Paragraph>
                        you can find more health info here:
                        <br />
                        <ExternalLink
                            href="https://www.mantotman.nl/en"
                            text="general sexual health, dutch & english"
                        />
                        <br />
                        <ExternalLink
                            href="https://www.mantotman.nl/en/stds-hiv"
                            text="sti's, hiv & prep"
                        />
                        <br />
                        <ExternalLink
                            href="https://nomorec.nl/"
                            text="everything about hepatitis c"
                        />
                        <br />
                        <ExternalLink
                            href="https://www.mantotman.nl/nl/snel-regelen/vaccinaties-tegen-hepatitis"
                            text="hepatitis a & b vaccination"
                        />
                        <br />
                        <ExternalLink
                            href="https://www.mantotman.nl/en/stds-hiv/all-stds/monkeypox"
                            text="monkey pox update"
                        />
                    </Paragraph>
                    <Paragraph>
                        need to get an urgent sti test and don't mind paying?
                        visit{' '}
                        <ExternalLink
                            href="https://onedayclinic.nl/en/?gclid=EAIaIQobChMI4Pu8haSoggMVRp4AAB3gsgZjEAEYASAAEgJGlvD_BwE"
                            text="onedayclinic.nl"
                        />
                    </Paragraph>

                    <Title as="h1" text="OneDayClinic" />
                    <Paragraph>
                        Protect yourself against throat, penile, and anal cancer
                        – for a discounted price!
                        <br />
                        Get your HPV vaccination during our special walk-in
                        sessions.
                    </Paragraph>
                    <Paragraph>
                        <strong>Date:</strong>
                        <br />
                        Wednesday, November 19
                        <br />
                        (More dates coming soon)
                        <br />
                        Time: 8:00 PM – 11:00 PM
                    </Paragraph>
                    <Paragraph>
                        Sign up (optional):
                        <br />
                        to register{' '}
                        <ExternalLink
                            href="https://docs.google.com/forms/d/1h1X7gI2lN7k2Zy-OHPt-1Ixn76nkGa5_FVf6C1Jx9gk/viewform?pli=1&pli=1&edit_requested=true"
                            text="click the link"
                        />
                        . This helps us estimate how many people to expect.
                        <br />
                        €200 per vaccine (cash or debit card)
                        <br />
                        2nd shot for complete immunization after 6 to 12 months
                    </Paragraph>
                    <Paragraph>
                        More information:
                        <br />
                        Want to learn more about the Human Papillomavirus (HPV)
                        and the vaccine? Check out our other informative posts
                        on{' '}
                        <ExternalLink
                            href="https://www.instagram.com/onedayclinic/"
                            text="the Instagram account"
                        />{' '}
                        or contact onedayclinic via:{' '}
                        <ExternalLink
                            href="https://www.instagram.com/direct/t/119597666093625"
                            text="instagram DM"
                        />{' '}
                        or{' '}
                        <ExternalLink
                            href="mailto:contact@onedayclinic.nl"
                            text="contact@onedayclinic.nl"
                        />
                        .
                    </Paragraph>
                </ContentBlock>
            </section>
        </ScrollToTop>
    );
};
